import api from './axios';
import { authHeader, noContentTypeHeader } from '../helpers';
import { authService } from './authentication.service';

export const versementService = {
    getAll,
    getForUser,
    getForUtam,
    postVersement,
    downloadForm,
    createCampagne
};

async function getAll() {
    return api.get('/Versement', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getForUser(utam, userId,numberItem, page= null, sortBy = null, sortOrder = null) {
    const params = new URLSearchParams({ numberItem });

    if (page) params.append('page', page);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    return api.get(`/Versement/utam/${utam}/user/${userId}?${params.toString()}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getForUtam(utamId, numberItem, page = null, sortBy = null, sortOrder = null) {
    const params = new URLSearchParams({ numberItem });

    if (page) params.append('page', page);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);

    return api
        .get(`/Versement/utam/${utamId}?${params.toString()}`, { headers: authHeader() })
        .then(authService.handleResponse);
}


async function postVersement(request, file) {
    const formData = new FormData();

    for (const key in request) {
        if (Array.isArray(request[key])) {
            if (request[key].length === 0) {
                formData.append(key, JSON.stringify([]));
            } else {
                request[key].forEach((v, i) => {
                    Object.keys(v).forEach(k => {
                        formData.append(`${key}[${i}].${k}`, v[k]);
                    });
                });
            }
        } else {
            if (typeof request[key] === 'object' && request[key] !== null) {
                formData.append(key, JSON.stringify(request[key]));
            } else {
                formData.append(key, request[key]);
            }
        }
    }

    formData.append('formulaire', file);

    return api.post('/Versement/fsd/creer', formData, {
        headers: noContentTypeHeader(file.name)
    })
        .then(authService.handleResponse);
}

async function downloadForm(idVersement) {
    return api.get(`/versement/${idVersement}/formulaire`, {
        headers: authHeader(),
        responseType: 'blob' // Required for handling file downloads
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const fileName = contentDisposition.match(/filename=(.+);/i)[1];

            const blob = response.data;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}

async function createCampagne(guidEltPatr, campagne) {
    return api.post(`/Patrimoine/campagne/create/${guidEltPatr}`, campagne, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}
